import { Stack, Button } from 'braid-design-system';
import React, { useState } from 'react';

import IndustryClassificationsField, {
  type SelectBoxIndustryGrouping,
} from 'src/components/IndustryClassificationsField/IndustryClassificationsField';
import LayoutBox from 'src/components/LayoutBox/LayoutBox';

interface Props {
  industryGroupings: SelectBoxIndustryGrouping[];
  setIndustryGroupings: (industryGroups: SelectBoxIndustryGrouping[]) => void;
}

const AddIndustries = ({ industryGroupings, setIndustryGroupings }: Props) => {
  const [editingMode, setEditingMode] = useState(false);

  if (editingMode) {
    return (
      <Stack space="medium">
        <LayoutBox maxWidth={400}>
          <IndustryClassificationsField
            placeholder="Please select"
            hideClearAll={true}
            industryGroupings={industryGroupings}
            setIndustryGroupings={setIndustryGroupings}
          />
        </LayoutBox>
        <LayoutBox maxWidth={70}>
          <Button onClick={() => setEditingMode(false)}>Done</Button>
        </LayoutBox>
      </Stack>
    );
  }

  return (
    <LayoutBox maxWidth={200}>
      <Button variant="ghost" onClick={() => setEditingMode(true)}>
        Add another industry
      </Button>
    </LayoutBox>
  );
};

export default AddIndustries;
